//查询背调服务购买状态请求参数
export default class ProductListForm {
  companyId = 0;
}
